import { useEffect, useState } from 'react';

/**
 * Custom hook that tracks whether the component is mounted.
 *
 * This hook provides a boolean value indicating whether the component
 * is currently mounted, which can be useful to avoid updating the state
 * of an unmounted component.
 *
 * @returns {boolean} A boolean indicating if the component is mounted.
 *
 * @example
 * const MyComponent = () => {
 *   const isMounted = useIsMounted();
 *
 *   useEffect(() => {
 *     if (isMounted) {
 *       // Perform some actions that require the component to be mounted
 *     }
 *   }, [isMounted]);
 *
 *   return <div>My Component</div>;
 */
function useIsMounted() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  return isMounted;
}

export default useIsMounted;
